export default __webpack_public_path__ + "static/media/productHealthCheckPackage1_Hk.8c10ff7b.webp";